export default "__VITE_ASSET__316cbc64__"